module.exports = __webpack_public_path__ + "static/media/m120-32.a0586e57.png";